import { LogisticElementData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const logisticElementsApi =
	apiResource<LogisticElementData>('logistic-elements');
